import $ from 'jquery'
import { debounce, isInViewport } from './utils/utils'

async function init (element, loadedItems) {
  let $this = createObject(element)
  $this.element.on('update', debounce(function () {update($this)}, 250))
  await initScrollMagic($this)

  $('footer .back-to-top-container').hide()

  $(window).on('scroll', function () {
    if ($(document).scrollTop() > 0) {
      if ($this.backToTopStatus) {
        $this.backToTop.css('opacity', 1)
      }
    } else {
      if ($this.backToTopStatus) {
        $this.backToTop.css('opacity', 0)
      }
    }

  })
}

function createObject (element) {
  return {
    element: element,
    loadingContainer: element.find('.infinite-scrolling-animation'),
    items: element.find('.item-wrapper'),
    backToTop: element.find('.infinite-scrolling-back-to-top-js'),
    backToTopStatus: false
  }
}

function update ($this) {
  let items = $this.items.filter('[data-visible=false][data-filter-visible=true]')
  if (items.length > 0 && isInViewport($this.element.find('.infinite-scrolling-marker'))) {
    displayElements($this)
  }
}

async function initScrollMagic ($this) {
  const ScrollMagicLib = await import(/* webpackChunkName: "scrollmagic" */ 'scrollmagic/scrollmagic/uncompressed/ScrollMagic')
  const ScrollMagic = ScrollMagicLib.default
  $this.scrollMagicController = new ScrollMagic.Controller({
    addIndicators: false
  })

  $this.backToTopScene = new ScrollMagic.Scene({
    triggerElement: $('footer').get(0),
    triggerHook: 'onEnter',
  })
    .addTo($this.scrollMagicController)
    .on('enter', function () {
      if ($this.items.filter('[data-visible=false][data-filter-visible=true]').length === 0) {
        $($this.backToTop).css('position', 'relative')
      }
    })
    .on('progress', (e) => {
      if (e.progress === 1) {
        $($this.backToTop).css('position', 'relative')
      } else {
        $($this.backToTop).css('position', 'fixed')
      }
    })
    .on('start', function (e) {
      if (e.scrollDirection === 'REVERSE' && $this.items.filter('[data-visible=false][data-filter-visible=true]').length === 0) {
        $($this.backToTop).css('position', 'fixed')
      }
    })

  $this.scrollMagicScene = new ScrollMagic.Scene({
    triggerElement: $this.element.find('.infinite-scrolling-marker')[0],
    triggerHook: 'onEnter'
  })
    .addTo($this.scrollMagicController)
    .on('enter', function () {
      displayElements($this)
    })
}

function displayElements ($this) {
  let items = $this.items.filter('[data-visible=false][data-filter-visible=true]')
  if (items.length > 0) {
    $this.backToTopStatus = true
    $this.loadingContainer.addClass('active')
    setTimeout(function () {
      items
        .slice(0, 9)
        .attr('data-visible', true)
        .show({
          effect: 'fade',
          complete: () => {
            $this.loadingContainer.removeClass('active')
            $this.element.trigger('update')
          }
        })
    }, 1000)
  } else {
    $this.loadingContainer.removeClass('active')
  }
}

export default init
